<div *ngIf="resource" class="ds-grid mt-6">
  <div class="row d-flex justify-content-center">
    <div [class.col-4]="!hasImage" [class.col-6]="hasImage">
      <a [href]="resource.value" class="resource-tile d-flex" target="_blank">
        <dcp-product-tile-content [imageTop]="false"
                                  [resource]="resource"></dcp-product-tile-content>
      </a>
    </div>
  </div>
</div>
